var root = document.documentElement;
root.removeAttribute('class', 'no-js');
root.setAttribute('class', 'js');

var $ = jQuery,
$body = $( 'body' ),
$h = $('header'),

extraMenuCtrl = {
	handlersBinded : false,
	initSetting : false,
	$menuBtn : '',
	init : function () {
		var self = this;

		// Add link for mobile submenu navigation
		if(self.initSetting == false){
			$("#navMain > ul li:has(ul) > a").append('<a href="#" class="btn subbutton">></a>');
			$("#navMain > ul li:has(ul) > ul").prepend('<a href="#" class="btn backbutton"><</a>');
			self.initSetting = true;
		}

		self.$menuBtn = $( '.menu-button' );

		if(!self.handlersBinded) self.bindHandlers();

	},
	destroy: function() {
		var self = this;
		// Remove link for mobile submenu navigation
		$('a.subbutton, a.backbutton').each(function(){
			$(this).remove();
		})

		self.$menuBtn = $( '.menu-button' );
		self.reset();

		self.initSetting = false;
	},
	bindHandlers: function(){
		var self = this;
		self.handlersBinded = true;
		$(document).on('click', '.menu-item-has-children a a.subbutton', function(e){
			e.preventDefault();
			var $btn = $(this);
			var ul = $btn.parent('a').next('ul');
			self.subMenu.show($btn, ul);
		})

		$(document).on('click', '.menu-item-has-children a.backbutton', function(e){
			e.preventDefault();
			var $btn = $(this);
			var ul = $btn.parent('ul');
			self.subMenu.show($btn, ul);
		});

		/*self.$menuBtn.click(function(e){
		 	e.preventDefault();
		 	self.show(self);
		 });*/

		self.$menuBtn.click(self.show.bind(self))

		// Extra - Close menu on opening other panels
		// $('.element').click(function(e) {
		// 	e.preventDefault();
		// 	self.reset();
		// });

	},
	show : function (e) {
		// Show menu and reset submenu
		var self = this;
		e.preventDefault();
		$body.toggleClass( 'active-menu' );
		self.$menuBtn.toggleClass( 'active-button' );

		if($body.hasClass('mag-show')){
			$body.removeClass('mag-show')
		};

		if($body.hasClass('search-show')){
			$body.removeClass('search-show')
		};

		self.subMenu.reset();
	},
	reset : function () {
		// Reset menu
		var self = this;
		$body.removeClass( 'active-menu' );
		self.$menuBtn.removeClass( 'active-button' );

		//self.subMenu.reset();
	},

		subMenu : {
			 // Submenu methods
			show : function ($link, ul) {
				// Show submenu
				if(ul.hasClass('sub-active')) $link.off('mouseenter mouseleave');
				ul.toggleClass('sub-active');
				$body.toggleClass( 'active-submenu' );
			},
			reset : function () {
				// Reset submenu
				var self = this;
				$body.removeClass( 'active-submenu' );
				$( 'ul.sub-active' ).removeClass( 'sub-active' );
			}
		}
}
